import store from '@/store/store';

function findPermission(to) {
  const rules = {
    m: 'maj',
    c: 'lecture',
    l: 'lecture',
  };
  const rule = rules[to.name.split('.')[0]];
  const module = to.name.split('.')[1];
  const element = (to.name.split('.')[2]).split('-')[0];
  const permission = {
    module,
    element,
    rule,
  };
  return store.getters['permissions/checkPermissions'](permission);
}

export default function autorisation(to) {
  if (!to.name.includes('.')) return true;
  return findPermission(to);
}
